export default "__VITE_ASSET__cJ8vv12z__";